import * as React from 'react';
import classnames from 'classnames';
import { useCartSlots } from '../../../slots/context.js';
import '../../../slots/summary-slot/context.js';
import '../../../slots/header-slot/context.js';
import { RemoveVoucherCodeContainer } from '../../VoucherCodes/RemoveVoucherCode/RemoveVoucherCodeContainer.js';
import '@grandvisionhq/common';
import '@grandvisionhq/forms';
import '@grandvisionhq/graphql';
import '@grandvisionhq/state';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '../../../operations/fragments/cart-details.js';
import '../../../operations/fragments/cart-validation-errors.js';
import '../../../operations/fragments/recover-inactive-cart-failure.js';
import '../../../operations/fragments/recover-inactive-cart-result.js';
import '../../../operations/mutations/add-cart-line-items.js';
import '../../../operations/mutations/add-cart-voucher-codes.js';
import '../../../operations/mutations/create-cart.js';
import '../../../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../../../operations/mutations/remove-cart-voucher-codes.js';
import '../../../operations/mutations/remove-cart-line-items.js';
import '../../../operations/mutations/update-cart-line-items.js';
import '../../../operations/mutations/replace-line-item-contact-lenses-bundle-benelux.js';
import '../../../operations/mutations/recover-inactive-cart.js';
import '../../../operations/queries/get-cart.js';
import '../../../operations/queries/get-total-line-items.js';
import '../../../operations/queries/get-cart-estimated-delivery.js';
import { CartDiscount } from '../components/CartDiscount.js';
import { MainTotal } from '../components/MainTotal.js';
import { PaymentMethodPrice } from '../components/PaymentMethodPrice.js';
import { Shipping } from '../components/Shipping.js';
import '@grandvisionhq/elements';
import { SubscriptionHeader } from '../components/SubscriptionHeader.js';
import { Subtotal } from '../components/Subtotal.js';
import { SubscriptionContainer } from '../containers/SubscriptionContainer.js';

const Mixed = ({ className , currency , labels , lineItems , prices , settings , subscription , voucherCodes , hideSubscriptionExplainer  })=>{
    const { Slots  } = useCartSlots();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('cart-totals', className),
        "data-t": "cart-totals"
    }, settings.showSubTotal && /*#__PURE__*/ React.createElement(Subtotal, {
        label: labels.subTotal,
        price: prices.subTotalPrice,
        currency: currency
    }), settings.showTotalDiscount && prices.discountPrice !== 0 && /*#__PURE__*/ React.createElement(CartDiscount, {
        label: labels.totalDiscount,
        price: -prices.discountPrice,
        currency: currency
    }), voucherCodes === null || voucherCodes === void 0 ? void 0 : voucherCodes.map((code)=>/*#__PURE__*/ React.createElement(RemoveVoucherCodeContainer, {
            key: code,
            voucherCode: code
        })
    ), prices.paymentMethodPrice && /*#__PURE__*/ React.createElement(PaymentMethodPrice, {
        label: labels.paymentMethodPrice,
        price: prices.paymentMethodPrice,
        currency: currency
    }), /*#__PURE__*/ React.createElement(Shipping, {
        labels: labels,
        price: prices.shippingPrice,
        currency: currency
    }), /*#__PURE__*/ React.createElement(MainTotal, {
        label: labels.todaysTotal,
        price: prices.totalPrice,
        currency: currency
    }), Slots.AfterTotals ? /*#__PURE__*/ React.createElement(Slots.AfterTotals, null) : null, /*#__PURE__*/ React.createElement(SubscriptionHeader, {
        header: labels.subscriptionHeader
    }), /*#__PURE__*/ React.createElement(SubscriptionContainer, {
        lineItems: lineItems,
        subscription: subscription,
        hideSubscriptionExplainer: hideSubscriptionExplainer
    }));
};

export { Mixed };
//# sourceMappingURL=Mixed.js.map
